export default () => {
  // eslint-disable-next-line no-restricted-globals
  self.onmessage = (message) => {
    if (message.data) {
      let data;
      try {
        data = JSON.parse(message.data);
      } catch (e) {
        console.log(e);
      }

      if (data && data.type === 'setTimeout') {
        setTimeout(() => {
          postMessage(message.data);
        }, data.time || 0);
      }
    }
  };
};
